import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "Util/getCustomColor";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const WrapperFooter = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
}));

export const DrawerOptionsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  marginTop: "8px",
  marginBottom: "24px",
}));

export const OptionsContainer = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "1fr 40px",
  gap: "12px",
}));

export const RemoveOptionButton = styled(IconButton)(({ disabled }: { disabled?: boolean }) => ({
  borderRadius: "8px",
  border: `1px solid ${disabled ? colors.gray400 : colors.error500}`,
  color: disabled ? colors.gray400 : colors.error500,
  height: "40px",
  width: "40px",

  "&:focus": {
    border: `1px solid ${disabled ? colors.gray400 : colors.error500}`,
  },
}));

export const OptionsInputLabel = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: getBrandCustom("darkPrimaryColor", "#308CDB"),
}));

export const RequiredLabel = styled("span")(() => ({
  color: colors.error500,
}));

export const DrawerMultipleOptions = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "90px 1fr 40px",
  gap: "12px",
}));

export const DrawerMultipleOptionsLabels = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "90px 1fr",
  gap: "12px",
}));

export const ErrorDisplay = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  lineHeight: "24px",
  color: colors.error600,
  alignItems: "center",
  display: "flex",
  gap: "5px",
}));

export const ErrorIcon = styled(InfoOutlinedIcon)(() => ({
  fontSize: "16px",
}));
